import { CURRENCY_CODE_OPTIONS, type CurrencyCode } from '@klear/constants/currency'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@klear/ui/components/select'
import { cn } from '@klear/ui/lib/utils'

type CurrencyReportSelectorProps = {
  value: CurrencyCode
  onChange: (currency: CurrencyCode) => void
  currencies: readonly CurrencyCode[]
  className?: string
}

export function CurrencyReportSelector({ value, onChange, currencies, className }: CurrencyReportSelectorProps) {
  if (currencies.length <= 1) {
    return null
  }

  const options = CURRENCY_CODE_OPTIONS.filter((opt) => currencies.includes(opt.value))

  return (
    <Select value={value} onValueChange={(next) => onChange(next as CurrencyCode)}>
      <SelectTrigger className={cn('w-[180px]', className)} aria-label="Report currency">
        <SelectValue placeholder="Select currency" />
      </SelectTrigger>
      <SelectContent>
        {options.map((opt) => (
          <SelectItem key={opt.value} value={opt.value}>
            {opt.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  )
}
